import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './PageHeader.scss';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  showBackButton = true 
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/admin');
  };

  return (
    <div className="page-header">
      <div className="page-header__content">
        {showBackButton && (
          <button 
            className="page-header__back-btn"
            onClick={handleBackClick}
            title="Back to Dashboard"
          >
            <FaArrowLeft />
            <span>Back to Dashboard</span>
          </button>
        )}
        <div className="page-header__text">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;

